import { useEffect, useState } from "react";
import { Download, Share, PlusSquare, X } from "lucide-react";
import { toast } from "sonner";
import { getInstallPrompt, clearInstallPrompt, isIOS, isStandalone } from "../lib/pwa";

export const InstallButton = () => {
    const [prompt, setPrompt] = useState(getInstallPrompt());
    const [standalone, setStandalone] = useState(isStandalone());
    const [guide, setGuide] = useState(false);

    useEffect(() => {
        const refresh = () => { setPrompt(getInstallPrompt()); setStandalone(isStandalone()); };
        window.addEventListener("pwa-install-changed", refresh);
        const mq = window.matchMedia("(display-mode: standalone)");
        mq.addEventListener?.("change", refresh);
        return () => { window.removeEventListener("pwa-install-changed", refresh); mq.removeEventListener?.("change", refresh); };
    }, []);

    if (standalone) return null;
    const ios = isIOS();
    if (!prompt && !ios) return null;

    const install = async () => {
        if (ios) { setGuide(true); return; }
        try {
            prompt.prompt();
            const { outcome } = await prompt.userChoice;
            if (outcome === "accepted") { toast.success("Aplikace se instaluje"); clearInstallPrompt(); }
        } catch { toast.error("Instalaci se nepodařilo spustit"); }
    };

    return (
        <>
            <button onClick={install} data-testid="install-app-button"
                    className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold uppercase tracking-wider border border-amber-500/60 text-amber-400 hover:bg-amber-500 hover:text-slate-900 rounded-sm transition-colors">
                <Download className="w-3.5 h-3.5" /> Nainstalovat aplikaci
            </button>
            {guide && (
                <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[70] flex items-end sm:items-center justify-center p-4" onClick={() => setGuide(false)}>
                    <div className="bg-white text-slate-900 border-2 border-slate-900 max-w-sm w-full p-6" onClick={(e) => e.stopPropagation()} data-testid="ios-install-guide">
                        <div className="flex items-start justify-between mb-4">
                            <h3 className="font-display text-lg font-bold">Přidat na plochu iPhonu</h3>
                            <button onClick={() => setGuide(false)}><X className="w-5 h-5 text-slate-400" /></button>
                        </div>
                        <ol className="space-y-3 text-sm">
                            <li className="flex gap-3"><span className="font-black text-amber-600">1.</span><span>V Safari klepněte dole na tlačítko <b>Sdílet</b> <Share className="inline w-4 h-4 -mt-0.5" /></span></li>
                            <li className="flex gap-3"><span className="font-black text-amber-600">2.</span><span>Vyberte <b>Přidat na plochu</b> <PlusSquare className="inline w-4 h-4 -mt-0.5" /></span></li>
                            <li className="flex gap-3"><span className="font-black text-amber-600">3.</span><span>Potvrďte <b>Přidat</b> — ikona Ceramixa se objeví na ploše</span></li>
                        </ol>
                        <p className="text-xs text-slate-500 mt-4">Funguje pouze v Safari (ne v Chrome pro iOS).</p>
                    </div>
                </div>
            )}
        </>
    );
};

export default InstallButton;
